// extracted by mini-css-extract-plugin
module.exports = {"BadgeWrapper":"DesignAwardBadge_BadgeWrapper__Z_j78"};